import { getItemDataById as IgetItemDataById } from '../ProductItem/queries/__generated__/getItemDataById';
import getItemDataByIdQuery from '../ProductItem/queries/itemDataById.graphql';

import { ICallbackParameters } from './model';

export const updateWishlistedCache = ({
  cache,
  products,
  productId,
}: ICallbackParameters & { productId: string }) => {
  const cachedData: IgetItemDataById = cache.readQuery({
    query: getItemDataByIdQuery,
    variables: { id: productId.toString() },
  });

  const wishlisted = products.includes(cachedData.vpProductById.id);
  const newProductData = {
    ...cachedData,
    vpProductById: { ...cachedData.vpProductById, wishlisted },
  };
  cache.writeQuery({
    query: getItemDataByIdQuery,
    variables: { id: productId.toString() },
    data: newProductData,
  });

  return cachedData;
};
